<h2 mat-dialog-title>Notes</h2>
<mat-dialog-content>
    <tyl-form-field style="width:400px;" label="Notes" hint="{{1000 - (note ? note.length : 0)}} characters left">
        <textarea matInput [(ngModel)]="note" maxlength="1000" rows="8" style="resize:none"></textarea>
    </tyl-form-field>
</mat-dialog-content>
<mat-dialog-actions>
    <div class='flex-footer-left'>

    </div>
    <div class='flex-footer-right'>
        <tyl-button image="Checkmark.png" label="Save" (clickEvent)="saveClick()"></tyl-button>
        <tyl-button image="cancel.png" label="Close" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>